import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { Business, DesignProject } from 'src/app/auth/models/login.model';
import { Client, Project } from '../../models/header.model';
import { setClient, setProject, unsetProject } from '../../../store/project/project.actions';
import { Router, RouterModule } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { selectclientList, selectDesignProjects, isSuperAdmin } from 'src/app/store/auth/auth.selectors';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { selectProjectConfiguration } from 'src/app/store/project/project.selectors';
import { ProjectData } from 'src/app/project-management/models/project.model';
import { CommonModule } from '@angular/common';
import { PopoverModule } from 'primeng/popover';
import { InputSwitch } from 'primeng/inputswitch';
import { MaterialModule } from 'src/app/modules/material/material.module';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    PopoverModule,
    OverlayPanelModule,
    InputSwitch,
    MaterialModule,
  ]
})
export class HeaderComponent implements OnInit, OnDestroy {

  clientsBusiness: Business[] = [];
  clients: Client[] = [];
  project: Project[] = [];
  clientSelected: number | null = null;
  nameClient: string = '';
  projectSelected: number | null = null;
  nameProject: string = '';
  logo: string = '';
  destroyed$ = new Subject();
  selectAllClient = false;
  isSuperAdmin: boolean = false;
  designsProjects: DesignProject[] = [];
  color = '';

  constructor(
    private store: Store<AppState>,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.store.select(isSuperAdmin).pipe(takeUntil(this.destroyed$)).subscribe(s => this.isSuperAdmin = s)
    this.store.select(selectDesignProjects).pipe(takeUntil(this.destroyed$)).subscribe(designs => {
      if (!designs.length) return;
      this.designsProjects = designs;
      if (this.projectSelected) {
        const designProject = this.designsProjects.find(d => d.idBusiness === this.projectSelected);
        const projectInfo = {
          projectId: this.projectSelected, 
          projectName: this.nameProject,
          color: designProject?.color ?? '',
          backgroundUrl: designProject?.urlLogoBackground ?? '',
          logoProject: designProject?.urlLogo ?? ''
        }
        this.store.dispatch(setProject({
          project: projectInfo
        }))
        this.saveProjectLocal(projectInfo);
      }
    });
    this.store.select(selectclientList).pipe(takeUntil(this.destroyed$)).subscribe((clients) => {
      if (clients.length > 0) {
        this.clientsBusiness = [...clients];
        if (this.isSuperAdmin) {
          this.clientsBusiness.unshift({
            id: 0,
            traderName: 'Todos',
            name: 'Todos',
            logo: '',
            businessList: []
          })
        }
        this.clients = this.clientsBusiness.map(item => {
          return {
            id: item.id,
            name: item.traderName,
            select: this.clientSelected === item.id,
            url: item.logo
          }
        });
        if (this.clientSelected) {
          const idx = this.clientsBusiness.findIndex(item => item.id === this.clientSelected);
          this.project = this.clientsBusiness[idx].businessList.map(item => {
            return {
              id: item.id,
              name: item.name,
              select: this.projectSelected === item.id
            }
          });
        }
        if (this.clients.length === 1) {
          this.selectClient(true, this.clients[0], true)
        }
      }
    });
    this.store.select(selectProjectConfiguration).pipe(takeUntil(this.destroyed$)).subscribe(({projectId, clientId, allClient, color}) => {
      this.color = color;
      if (projectId > -1 && clientId > -1 && this.clientsBusiness.length > 0) {
        this.clientSelected = clientId;
        this.projectSelected = projectId;
        const idx = this.clientsBusiness.findIndex(item => item.id === clientId);
        if (idx === -1) return;
        // this.nameClient = this.clientsBusiness[idx].name;
        const clientSelected = this.clients.find(item => item.id === clientId);
        if (clientSelected) {
          this.nameClient = clientSelected.name;
          clientSelected.select = true;
        }
        this.project = this.clientsBusiness[idx].businessList.map(item => {
          if (item.id === this.projectSelected) {
            this.nameProject = item.name
          }
          return {
            id: item.id,
            name: item.name,
            select: item.id === this.projectSelected
          }
        });
      } else if (allClient) {
        this.selectAllClient = allClient;
        this.clientSelected = 0;
        this.nameClient = 'Todos';
        const clientSelected = this.clients.find(item => item.id === 0);
        if (clientSelected) {
          this.nameClient = clientSelected.name;
          clientSelected.select = true;
        }
      } else if (projectId === -1 && clientId === -1) {
        this.clearAll(false)
      }
    })
  }

  ngOnDestroy(): void {
    this.destroyed$.next(null);
    this.destroyed$.complete();
  }

	selectClient(check: boolean, client: Client, projectAuto = false) {
		if (check) {
			this.clientSelected = client.id;
			this.nameClient = client.name;
			const idx = this.clientsBusiness.findIndex(
				(item) => item.id === client.id
			);
			this.project = this.clientsBusiness[idx].businessList.map((item) => {
				return {
					id: item.id,
					name: item.name,
					select: false,
				};
			});
			this.logo = client.url;
			this.store.dispatch(
				setClient({ clientId: this.clientSelected, logo: client.url ?? '' })
			);
			if (client.id === 0) {
				this.saveProjectLocal({});
			}
			if (client.id !== 0) {
				this.selectAllClient = false;
			}
			if (this.project.length === 1 && projectAuto) {
				this.selectProject(true, this.project[0]);
			}
		} else {
			this.clearAll();
		}
		if (!projectAuto && !this.selectAllClient) {
			localStorage.removeItem('project');
			this.navigateHome();
		}
	}

	selectProject(check: boolean, project: Project) {
		if (check) {
			this.projectSelected = project.id;
			this.nameProject = project.name;
			const designProject = this.designsProjects.find(
				(d) => d.idBusiness === project.id
			);
			const projectInfo = {
				projectId: this.projectSelected,
				projectName: this.nameProject,
				color: designProject?.color ?? '',
				backgroundUrl: designProject?.urlLogoBackground ?? '',
				logoProject: designProject?.urlLogo ?? '',
				// Mobile
        colorMobile: designProject?.colorMobile ?? '',
        secuColor: designProject?.secuColor ?? '',
        urlLogoLogin: designProject?.urlLogoLogin ?? '',
        urlLogoSplash: designProject?.urlLogoSplash ?? '',
        urlLogoHome: designProject?.urlLogoHome ?? '',
			};
			this.store.dispatch(
				setProject({
					project: projectInfo,
				})
			);
			this.saveProjectLocal(projectInfo);
		} else {
			this.projectSelected = null;
			this.nameProject = '';
			this.store.dispatch(
				setProject({
					project: {
						projectId: -1,
						projectName: '',
						color: '',
						backgroundUrl: '',
						logoProject: '',
					},
				})
			);
			localStorage.removeItem('project');
			this.navigateHome();
		}
	}

	saveProjectLocal(project: Partial<ProjectData>) {
		const data = {
			projectId: this.projectSelected || -1,
			clientId: this.clientSelected || 0,
			projectName: this.nameProject,
			logo: this.logo,
			allClient: this.selectAllClient,
			...project,
		};
		localStorage.setItem('project', btoa(JSON.stringify(data)));
	}

  navigateHome () {
    const url = this.router.url.split('/')[-1];
    if (url !== 'home') {
      this.router.navigate(['/admin/home'])
    }
  }

  clearAll (store = true) {
    this.clientSelected = null;
    this.project = [];
    this.projectSelected = null;
    this.nameProject = '';
    this.nameClient = '';
    this.selectAllClient = false;
    if (store) {
      this.store.dispatch(unsetProject());
    }
  }

}
